"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function (frame) {
    virtual.send('reportDevInfo');
}; });



// WEBPACK FOOTER //
// ./src/actions/receive/actions/devLoginResp.ts